import type {
	AddedDebtFormItem,
	ConfirmDebtItem,
	ConfirmDebtPayload,
	ResolvedConfirmDebtContext,
	ResolvedConfirmDebtItem,
} from "../types";
import type { DebtType } from "./debt-types";

export const resolveConfirmDebts = (
	debts: ConfirmDebtItem[] | undefined
): ResolvedConfirmDebtItem[] =>
	(debts ?? []).map((debt) => ({
		...debt,
		type: debt.type?.trim() ?? "",
		description: debt.description?.trim() ?? "",
		bank: debt.bank?.trim() ?? "",
	}));

export const emptyAddedDebt = (): AddedDebtFormItem => ({
	type: "",
	amount: undefined,
	saved: false,
});

export const toConfirmDebtPayload = (
	values: { addedDebts?: AddedDebtFormItem[] },
	context: Pick<ResolvedConfirmDebtContext, "isCoapplicant">
): ConfirmDebtPayload => ({
	confirm: true,
	isCoapplicant: context.isCoapplicant,
	debts: (values.addedDebts ?? []).map(({ type, amount }) => ({
		// The form schema only lets a debt through once its type is a DebtType.
		type: type as DebtType,
		amount: Number(amount ?? 0),
	})),
});
